import { render, staticRenderFns } from "./FunnelChart.vue?vue&type=template&id=ba376752&scoped=true"
import script from "./FunnelChart.vue?vue&type=script&lang=js"
export * from "./FunnelChart.vue?vue&type=script&lang=js"
import style0 from "./FunnelChart.vue?vue&type=style&index=0&id=ba376752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba376752",
  null
  
)

export default component.exports